import httpClient from '../config/httpClient';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
  subscribeToIntegrationStatus,
} from './integrationImport';

export const connectSageHR = async (companyId, userId, subdomain, apiKey) => {
  const { data } = await httpClient.post('/sageHRConnect', {
    companyId,
    userId,
    subdomain,
    apiKey,
  });
  return data;
};

export const disconnectSageHR = async (companyId, userId) => {
  const { data } = await httpClient.post('/sageHRDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getSageHREmployees = async (companyId) => {
  const { data } = await httpClient.post('/sageHRGetEmployees', { companyId });
  return data;
};

export const autoMapSageHREmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/sageHRAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const saveSageHRMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/sageHRSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncSageHRTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/sageHRSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const exportAllSageHREmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/sageHRExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const previewSageHRImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/sageHRPreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const importSageHREmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/sageHRImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToSageHRImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'sagehr', onUpdate);

export const getSageHRImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'sagehr', logId);

const DISCONNECTED_SAGEHR_STATUS = {
  connected: false,
  subdomain: null,
  connectedAt: null,
  connectedBy: null,
  employeeMappings: {},
  employeeMappingsUpdatedAt: null,
  lastSyncAt: null,
  lastSyncStats: null,
};

export const subscribeToSageHRStatus = (companyId, onUpdate) => {
  return subscribeToIntegrationStatus(
    companyId,
    'sagehr',
    ({ exists, data: d }) => {
      if (!exists || !d.connected) {
        onUpdate(DISCONNECTED_SAGEHR_STATUS);
        return;
      }
      onUpdate({
        connected: true,
        subdomain: d.subdomain || null,
        connectedAt: d.connectedAt ? new Date(d.connectedAt) : null,
        connectedBy: d.connectedBy || null,
        employeeMappings: d.employeeMappings || {},
        employeeMappingsUpdatedAt: d.employeeMappingsUpdatedAt
          ? new Date(d.employeeMappingsUpdatedAt)
          : null,
        lastSyncAt: d.lastSyncAt ? new Date(d.lastSyncAt) : null,
        lastSyncStats: d.lastSyncStats || null,
      });
    }
  );
};
